export const spacing = {
  25: 3.125,
  50: 6.25,
};
